export default [
  {
    // Greendale Community College
    id: '10002',
    activationLinkEnabled: false,
    aiEnabled: false,
    allowJoinExternalClasses: false,
    allowStudentProfilePhoto: true,
  },
  {
    // City College
    id: '10003',
    activationLinkEnabled: true,
    aiEnabled: true,
    allowJoinExternalClasses: true,
    allowStudentProfilePhoto: true,
  },
];
